<template>
  <div
    v-if="show"
    :id="id"
    class="absolute top-[1.0714285714rem] right-[1.0714285714rem] w-[2.8571428571rem] h-[2.8571428571rem] z-20"
  >
    <div
      class="h-full w-full cursor-pointer bg-black-20 hover:bg-black-40 rounded-full flex items-center justify-center pointer-events-auto"
      @click.stop.prevent="onToggle"
      @mousedown.stop.prevent
    >
      <Icon
        :id="id"
        icon="heart"
        pack-prefix="fas"
        class="text-[1.1428571429rem]"
        :class="props.isFavorite
          ? 'text-accent-rose fill-accent-rose'
          : 'text-white-60 fill-white-60'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import Icon from '../atom/icon.vue'
import { CONTENT_TYPES  } from '~~/shared/utils/contentTypes';

interface Props {
  loggedIn?: boolean
  itemType?: string
  isFavorite: boolean
  id?: string
}

const props = defineProps<Props>()

const emit = defineEmits<(e: 'toggle') => void>()

const show = computed(() => {
  return !!props.loggedIn && props.itemType !== CONTENT_TYPES.VIDEO
})

const onToggle = () => {
  emit('toggle')
}
</script>
